






















































import { Vue, Component } from 'vue-property-decorator';
import { OPTHINES } from './config';
import { getWorkType, getAreas, prizeList } from './api';
import { Tab, Tabs, Picker, List, Popup } from 'vant';

Vue.use(Tab)
  .use(Tabs)
  .use(Picker)
  .use(List)
  .use(Popup);
@Component({
  components: {},
})
export default class Prize extends Vue {
  option = OPTHINES;
  WorkTypeData = ['毛笔书法', '中国画', '西画'];
  AreasData: any[] = ['一等奖', '二等奖', '三等奖', '人气奖'];
  showPicker: boolean = false;
  value: string = '毛笔书法';
  active: number = 0;
  // 需要的值
  county: string = '毛笔书法';
  workType: string = '一等奖';
  type: any = '';
  // list
  page: number = 1;
  loading: boolean = false;
  finished: boolean = false;
  list: any = [];
  created() {
    this.type = this.$route.query.type;
    console.log('this.type', this.type);
  }
  onConfirm(e: any, index: number) {
    this.value = e;
    this.showPicker = false;
    if (e === '西画') {
      this.county = '西洋画';
    } else {
      this.county = e;
    }
    this.list = [];
    this.page = 1;
    this.onLoad();
  }
  onChange(index: number, e: any) {
    this.workType = e;
    this.list = [];
    this.page = 1;
    this.onLoad();
  }
  async onLoad() {
    // 异步更新数据
    const data = {
      page: this.page,
      project_type: this.county,
      work_type: this.type,
      prize_type: this.workType,
    };
    const res = await prizeList(data);
    this.loading = false;
    this.page++;
    this.list = [...this.list, ...res.data];
    if (res.data === '') {
      this.finished = true;
    }
  }
  enterDetail(e: any) {
    this.$router.push(`./detail?id=${e.id}`);
  }
}
